import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const POLL_INTERVAL_MS = 60_000; // 60s

const EMPTY = {
  total: 0,
  counts: {
    relances_overdue: 0,
    relances_today: 0,
    docs_expired: 0,
    docs_expiring_soon: 0,
    offer_alerts: 0,
    recent_activity: 0,
  },
  items: {
    relances_overdue: [],
    relances_today: [],
    docs_expired: [],
    docs_expiring_soon: [],
    offer_alerts: [],
  },
  updated_at: null,
};

/**
 * useNotifications — global polling hook.
 * Returns latest notification summary + a manual refresh function.
 */
export function useNotifications() {
  const [data, setData] = useState(EMPTY);
  const [loading, setLoading] = useState(true);

  const fetchSummary = useCallback(async () => {
    try {
      const r = await api.get("/notifications/summary");
      setData(r.data || EMPTY);
    } catch (error) {
      // Keep stale data on transient failures (offline, 5xx). Surface to console for debugging.
      console.error("[useNotifications] summary fetch failed:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSummary();
    const id = setInterval(fetchSummary, POLL_INTERVAL_MS);
    const onVis = () => { if (!document.hidden) fetchSummary(); };
    const onRefresh = () => fetchSummary();
    document.addEventListener("visibilitychange", onVis);
    window.addEventListener("athlynx:notifs-refresh", onRefresh);
    return () => {
      clearInterval(id);
      document.removeEventListener("visibilitychange", onVis);
      window.removeEventListener("athlynx:notifs-refresh", onRefresh);
    };
  }, [fetchSummary]);

  return { data, loading, refresh: fetchSummary };
}
